import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';

type NextCloudResponseSuccess = {
  url: string;
  status: true;
};

type NextCloudResponseFailure = {
  message: string;
  status: false;
};

type NextCloudResspons = NextCloudResponseSuccess | NextCloudResponseFailure;

export const getNextCloudUrl = async ({
  woUid,
  visitUid,
}: {
  woUid: string;
  visitUid: string;
}): Promise<NextCloudResspons> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/nc-url?${new URLSearchParams({
      woUid,
      visitUid,
    })}`,
    { method: 'GET' }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }
  const response = (await fetchResponse.json()) as NextCloudResspons;

  if (!response.status) {
    throw new ApiError({ message: response.message } as ErrorResponseDto);
  }

  return response;
};
